/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualSalaryDto } from '../../models/backend-actual-salary-dto';
import { BackendActualSalaryRequestDto } from '../../models/backend-actual-salary-request-dto';

export interface MonitoringActualsSalariesUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body: BackendActualSalaryRequestDto;
}

export function monitoringActualsSalariesUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsSalariesUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsSalariesUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualSalaryDto>;
    }),
  );
}

monitoringActualsSalariesUpdate$XWwwFormUrlencoded.PATH = '/api/monitoring/actuals/salaries/{id}/';
